"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.activitySchedulerInstanceNames = void 0;
var activitySchedulerInstanceNames;
(function (activitySchedulerInstanceNames) {
    activitySchedulerInstanceNames["GEMCO_KIT_DELIVERY"] = "gemcoKitDelivery";
    activitySchedulerInstanceNames["PRECISION_KIT_DELIVERY"] = "precisionKitDelivery";
    activitySchedulerInstanceNames["PCI_EMAIL_SENDING"] = "pciEmailSending";
    activitySchedulerInstanceNames["PCI_LETTER_SENDING"] = "pciLetterSending";
    activitySchedulerInstanceNames["US_CALL_CENTER"] = "usCallCenter";
    activitySchedulerInstanceNames["UK_CALL_CENTER"] = "ukCallCenter";
    activitySchedulerInstanceNames["SMS_SENDING_UK"] = "smsSendingUK";
    activitySchedulerInstanceNames["SMS_SENDING_US"] = "smsSendingUS";
    activitySchedulerInstanceNames["UK_SEND_PRIORITIZED_OUTREACH"] = "ukSendPrioritizedOutreach";
    activitySchedulerInstanceNames["US_SEND_PRIORITIZED_OUTREACH"] = "usSendPrioritizedOutreach";
    activitySchedulerInstanceNames["GENERIC"] = "generic";
    activitySchedulerInstanceNames["AFTER_SPECIFIC_DATE"] = "afterSpecificDate";
    activitySchedulerInstanceNames["BEFORE_SPECIFIC_DATE"] = "beforeSpecificDate";
    activitySchedulerInstanceNames["UK_SEND_PUSH_NOTIFICATION"] = "sendPushNotificationUk";
    activitySchedulerInstanceNames["US_SEND_PUSH_NOTIFICATION"] = "sendPushNotificationUs";
    activitySchedulerInstanceNames["UK_EMAIL_SENDING"] = "ukEmailSending";
    activitySchedulerInstanceNames["UK_LETTER_SENDING"] = "ukLetterSending";
})(activitySchedulerInstanceNames || (exports.activitySchedulerInstanceNames = activitySchedulerInstanceNames = {}));
